import { environmentBase } from './environment.base';

export const environment = {
  ...environmentBase,
  production: true,
  slimPackage: 'Enabled',
  siteUrl: 'https://backoffice.au.apsis.one/',
  oneUrl: 'https://app.apsis.one/',
  apiBaseUrl: 'https://gw.au.apsis.one/backoffice/',
  audienceBaseUrl: 'https://pub.aud.apsis.one/pr/',
  avatarBaseUrl: 'https://avatar.au.apsis.one/',
  emailBaseUrl: 'https://pub.email.apsis.one/',
  proSyncBaseUrl: 'https://gw.prosync.apsis.one/backoffice/',
  smsBaseUrl: 'https://gw.sms.apsis.one/',
  maBaseUrl: 'https://ysyztp1bn0.execute-api.eu-west-1.amazonaws.com/dev/',
  ecomBaseUrl: 'https://gw.ecom.apsis.one/',
  integrationsBaseUrl: 'https://integrations.apsis.one/',
  webVersionUrl: 'https://web.apsis.one/preview/',
  privateDomainUrl: 'https://pub.private-domain.apsis.one/',
  auth0: {
    clientID: 'ldZs3Z1paNbizHTIrto6t8KaMLSDktry',
    domain: 'enter.apsis.one',
    audience: 'https://apsis.one/support',
    issuer: 'https://enter.apsis.one/',
    tenant: 'apsis-one-prod',
  },
};
